import { combineSlices, configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import * as Sentry from '@sentry/react';

import { listenerMiddleware } from './middlewares/listener';
import { apiSlice, appSlice, authCredentialsSlice, kybAuthSlice, modalsSlice } from './slices';

// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
const sentryReduxEnhancer = Sentry.createReduxEnhancer({
	// CRITICAL SECURITY: Exclude sensitive credentials from Sentry payloads
	stateTransformer: (state: RootState) => ({
		...state,
		authCredentials: {
			// Never send plaintext credentials to Sentry
			credentials: state.authCredentials.credentials ? '[REDACTED]' : null,
		},
	}),
});
const reducer = combineSlices(apiSlice, kybAuthSlice, modalsSlice, appSlice, authCredentialsSlice);
export type RootState = ReturnType<typeof reducer>;
export const makeStore = (preloadedState?: Partial<RootState>) => {
	const storeConfig = configureStore({
		reducer,
		preloadedState,
		middleware: (getDefaultMiddleware) =>
			getDefaultMiddleware().prepend(listenerMiddleware.middleware).concat(apiSlice.middleware),
		enhancers: (getDefaultEnhancer) => getDefaultEnhancer().concat(sentryReduxEnhancer),
	});
	setupListeners(storeConfig.dispatch);
	return storeConfig;
};
export const store = makeStore();
export type AppStore = typeof store;
export type AppDispatch = AppStore['dispatch'];
